import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { IDecisionOrganizationForm } from 'DecisionPackage/MainModule/interfaces/IDecisionOrganizationForm';

import styles from './DecisionActSubject.module.scss';
import { DecisionActSubjectInfo } from './components/DecisionActSubjectInfo';

interface IDecisionActSubjectProps {
  organization: IDecisionOrganizationForm | undefined;
  isDecision: boolean | undefined;
}

export const DecisionActSubject = ({ organization, isDecision }: IDecisionActSubjectProps) => {
  return (
    <div className={styles.Wrapper}>
      <FieldBlock label={'Сведения о контролируемом лице'} />
      <div className={styles.SubjectAdd}>
        <DecisionActSubjectInfo
          name={`organization`}
          isAutocomplete={organization?.isAutocomplete}
          inn={organization?.inn}
          ogrn={organization?.ogrn}
          subjectType={organization?.organizationType}
          kpp={organization?.kpp}
          smevRequestStatus={organization?.smevRequestStatus}
          rafpNza={organization?.rafpNza}
          snils={organization?.snils}
          checkSubjectResult={organization?.checkSubjectResult || null}
          ervkId={organization?.ervkId}
          isDecision={isDecision}
        />
      </div>
    </div>
  );
};
